<button p500-ui-circled-button class="c-button c-button--bordered mr-5" (click)="openModal()">
  <p500-ui-icon [name]="iconName" size="16px"></p500-ui-icon>
</button>
<ng-template #content>
  <ng-content></ng-content>
</ng-template>
